import editing from 'assets/img/icons/spot-illustrations/21.png';
import React, { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Starter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/dashboards/tickets');
  }, [])

  return (
    <Card>
      <Card.Body className="overflow-hidden p-lg-6">
        <Row className="align-items-center justify-content-between">
          <Col lg={6}>
            <img src={editing} className="img-fluid" alt="" />
          </Col>
          <Col lg={6} className="ps-lg-4 my-5 text-center text-lg-start">
            <h3 className="text-primary">Carregando...</h3>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Starter;